export const generateYoutubeThumbnailUrl = (videoUrl?: string | null): string | null => {
  if (!videoUrl) return '';

  const url = new URL(videoUrl);

  let videoId: string = '';

  if (url.hostname.includes('youtu.be')) {
    videoId = url.pathname.replace('/', '');
  } else {
    videoId = url.searchParams.get('v');
  }

  if (!videoId) return '';

  return `https://img.youtube.com/vi/${videoId}/0.jpg`;
};
